import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// The static pre-render (scripts/prerender.js) writes crawler-visible HTML into
// #root, so search engines and the first paint get real content. That markup is
// produced by a client render, not true SSR, so we mount with createRoot (React
// renders cleanly over it) rather than hydrateRoot, which would reject the
// non-SSR markup. The SEO benefit — real content in the initial response — is
// fully retained either way.
createRoot(rootElement).render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
